import { IItemCache } from '@ms/items-view/lib/private/models/IItemCacheObserver';
import { itemThumbnailControl } from '@ms/items-view/lib/private/controls/itemThumbnailControl';
import {
    IControlHandler,
    createControlHandler,
} from '@ms/items-view/lib/private/addons/registerControlHandler';
import {
    IItemCacheThunkAction,
    IItemCacheDispatch,
} from '@ms/items-view/lib/private/store/actions/ItemCacheActions';

import { fileKeyFacet } from '../Schema/Facets';
import { AttachmentModel } from 'owa-attachment-full-view';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { getParameterStore } from '../store/ParametersStore';

export const fileThumbnailControlHandler: IControlHandler<
    typeof fileKeyFacet.type,
    typeof itemThumbnailControl.type
> = createControlHandler()(getItemThumbnailControlHandler);

function getItemThumbnailControlHandler(): IItemCacheThunkAction<typeof itemThumbnailControl.type> {
    return (dispatch: IItemCacheDispatch) => {
        return itemThumbnailControlHandler;
    };
}

function itemThumbnailControlHandler(
    itemCache: IItemCache,
    props: typeof itemThumbnailControl.inputType
): typeof itemThumbnailControl.returnType {
    const { itemKey } = props;

    const { id } = itemCache.demandItemFacet(fileKeyFacet, itemKey);
    const attachmentId = { Id: id, mailboxInfo: getParameterStore().mailboxInfo };
    const attachment: AttachmentModel = getAttachment(attachmentId);

    if (attachment && attachment.thumbnailImage.url) {
        return {
            thumbnail: {
                url: attachment.thumbnailImage.url,
                width: 106,
                height: 83,
            },
        };
    }
    return {};
}
